import store from '../store/store';

export default () => store.calendarConfiguration?.WorkingHoursTimeZone?.TimeZoneId;
